import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import { ParagraphSmallText } from '../../../components/Texts';
import { formatDate } from '../../../common/date';

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  height: fit-content;
  margin-top: -10px;
  margin-bottom: -10px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  height: fit-content;
  color: ${({ theme }) => theme.text.regular};
`;

const Tbody = styled.tbody``;

const Tr = styled.tr`
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  @media ${PHONE_MEDIA_QUERY} {
    padding: 12px;
  }
`;

const Td = styled.td`
  padding: 16px;
  vertical-align: middle;
  border-bottom: 1px solid ${({ theme }) => theme.border.secondary};
  font-size: 14px;
`;

const getTypeKey = (operationType) => {
  const keys = {
    TRANSACTION_FEE: 'rewardsPage.type.transactionFee',
    FIAT_DEPOSIT: 'rewardsPage.type.firstDeposit',
    CASHBACK: 'rewardsPage.type.cashback',
    CASHBACK_SKR: 'rewardsPage.type.cashback',
  };
  return keys[operationType] || 'rewardsPage.type.cashback';
};

const getStatusKey = (status) => {
  const keys = {
    PENDING: 'rewardsPage.status.pending',
    PAID: 'rewardsPage.status.paid',
  };
  return keys[status] || status;
};

const Status = styled.div`
  background-color: ${({ theme }) => theme.primary.background};
  border: 1px solid ${({ theme }) => theme.primary.ultraLight};
  color: ${({ theme }) => theme.primary.primary};
  padding: 6px 10px;
  border-radius: 8px;
  width: fit-content;
  ${({ status, theme }) =>
    status === 'PENDING' &&
    `
    background-color: ${theme.status.warning.background};
    border: 1px solid ${theme.status.warning.background};
    color: ${theme.status.warning.primary};
  `}
`;

const Amount = styled.div`
  color: ${({ theme }) => theme.status.success.primary};
  font-weight: 600;
`;

const Row = ({ reward, t }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <Tr key={reward.id}>
      <Td>
        <Status status={reward.status}>
          <p>{t(getStatusKey(reward.status))}</p>
        </Status>
      </Td>
      <Td>
        <div>
          <p>{t(getTypeKey(reward.operationType))}</p>
        </div>
      </Td>
      {!isMobile && (
        <>
          <Td>
            <div>
              <p>{reward.currency}</p>
            </div>
          </Td>
        </>
      )}
      <Td>
        <Amount>
          <p>${reward.amount}</p>
        </Amount>
      </Td>
      {!isMobile && (
        <Td>
          <div>
            <p>{formatDate(new Date(reward.createdAt))}</p>
          </div>
        </Td>
      )}
    </Tr>
  );
};

const RewardsTable = ({ data }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <TableContainer>
      <Table>
        <thead>
          <Tr>
            <Td>{t('rewardsPage.table.status')}</Td>
            <Td>{t('rewardsPage.table.type')}</Td>
            {!isMobile && <Td>{t('rewardsPage.table.paymentCurrency')}</Td>}
            <Td>{t('rewardsPage.table.amount')}</Td>
            {!isMobile && <Td>{t('rewardsPage.table.date')}</Td>}
          </Tr>
        </thead>
        <Tbody>
          {data.map((reward, i) => {
            return <Row key={`${reward.id}-${i}`} reward={reward} t={t} />;
          })}
          {data.length === 0 && (
            <Tr>
              <Td
                colSpan={isMobile ? 3 : 6}
                style={{ textAlign: 'center', padding: '20px' }}
              >
                <ParagraphSmallText>{t('rewardsPage.table.noCashbackYet')}</ParagraphSmallText>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default RewardsTable;
